module.exports = __webpack_public_path__ + "static/nosotros-img-b766493406fed28a98adf60cd7bc6c85.jpg";